import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function PillIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M22.1364 1C19.7686 1 17.5421 1.92218 15.8695 3.59613L3.59676 15.8688C1.92282 17.5434 1 19.7693 1 22.1364C1 27.0236 4.97636 31 9.86365 31C12.2327 31 14.4579 30.0778 16.1305 28.4039L28.4032 16.1318C30.0785 14.4572 31 12.2313 31 9.86358C30.9999 4.97636 27.0236 1 22.1364 1ZM10.5801 14.671L6.48916 18.7612C5.58763 19.6628 5.0909 20.8619 5.0909 22.1364C5.0909 22.5132 4.78594 22.8182 4.40906 22.8182C4.03219 22.8182 3.72723 22.5132 3.72723 22.1364C3.72723 20.4971 4.36509 18.9563 5.52499 17.7971L9.61589 13.7069C9.88225 13.4405 10.3137 13.4405 10.58 13.7069C10.8464 13.9731 10.8464 14.4046 10.5801 14.671ZM26.4749 14.2035L20.8207 19.8571L12.1434 11.1787L17.7978 5.52435C18.9563 4.36515 20.4971 3.72723 22.1364 3.72723C25.5202 3.72723 28.2727 6.47983 28.2727 9.86358C28.2727 11.5029 27.6348 13.0443 26.4749 14.2035Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
